export const PARTNER_SEX = {
  WOMAN: 'MUJER',
  MAN: 'HOMBRE',
};
